<div [formGroup]="parentFormGroup">
  <textarea
    [formControlName]="control"
    class="fill"
    id="textArea"
    data-cy="textArea"
    rows="6"
  ></textarea>
</div>
